'use strict';

var React = require('react');
var styled = require('styled-components');
var spacing = require('../../theme/spacing.js');
require('./Cells/cell.js');
require('./Cells/cellActions.js');
var cellCheckbox = require('./Cells/cellCheckbox.js');
require('../Chip/component.js');
require('../Tooltip/component.js');
require('./Cells/cellIcon.styles.js');
require('../Pill/pill.styles.js');
require('../Pill/pillButton.styles.js');
require('../forms/Select/Control.js');
require('../forms/Select/Option.js');
require('../forms/Select/multi-select/OptionMulti.js');
require('../forms/Select/multi-select/ControlMulti.js');
require('./Cells/cellSubText.styles.js');
require('../forms/Switch/component.js');
require('../Tag/component.js');
require('./Cells/header.js');
require('../Icon/component.js');
var headerCheckbox = require('./Cells/headerCheckbox.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const SELECT_CHECKBOX_WIDTH_PX = 15;
const areAllRowsSelected = (keyField, rows, selectedRows) => rows.length > 0 && rows.map(d => d[keyField]).every(r => selectedRows.includes(r));
function useSelectableRows(engine, withSelectableRows) {
    const theme = styled.useTheme();
    const columnsWithSelectable = React.useMemo(() => {
        if (!withSelectableRows) {
            return [];
        }
        const selectCheckboxColWidthPx = spacing.px(theme.designTokens.tableFirstColumCellPaddingLeft) +
            spacing.px(theme.designTokens.tableCellPadding) +
            SELECT_CHECKBOX_WIDTH_PX;
        const makeToggleRowSelected = (d) => () => {
            engine.toggleRowSelected(d[engine.state.keyField]);
        };
        const toggleSelectAll = () => {
            if (areAllRowsSelected(engine.state.keyField, engine.state.data, engine.state.selectedRows)) {
                engine.clearAllSelectedRows();
            }
            else {
                engine.setAllSelectedRows(engine.state.data.map(d => d[engine.state.keyField]));
            }
        };
        return [
            {
                key: engine.state.keyField,
                renderHeader: headerProps => (React__default.default.createElement(headerCheckbox.HeaderCheckbox, { ...headerProps, name: "selectAll", onChange: toggleSelectAll, checked: areAllRowsSelected(engine.state.keyField, engine.state.data, engine.state.selectedRows), resizeEnabled: false })),
                renderCell: (data, cellProps) => (React__default.default.createElement(cellCheckbox.CellCheckbox, { ...cellProps, name: data[engine.state.keyField], onChange: makeToggleRowSelected(data), checked: engine.state.selectedRows.includes(data[engine.state.keyField]) })),
                width: selectCheckboxColWidthPx,
            },
        ];
    }, [
        withSelectableRows,
        theme.designTokens.tableFirstColumCellPaddingLeft,
        theme.designTokens.tableCellPadding,
        engine,
    ]);
    return { columnsWithSelectable };
}

exports.useSelectableRows = useSelectableRows;
//# sourceMappingURL=useSelectableRows.js.map
